import {reisy, node, font, decl} from 'reisy';
const BASE_URL = '//j.pagestrip.com/fonts/1/';

const Fonts = {};
export const KENT_FONTS = ['title', 'subtitle', 'text', 'aside', 'pagestrip'];

const ABS_URL = /^(data:|(\w+:)?\/\/)/;

export function fontDef(name, defs) {
	return node('', ~KENT_FONTS.indexOf(name.replace('-override', '')) ? `kent-font-${name}` : name, [], font(...defs.map(def => [
		['src', decl(`url(${ABS_URL.test(def.url) ? '' : BASE_URL}${def.url}) format('woff')`)],
		['font-weight', decl(def.weight)],
		['font-style', decl(def.style)],
	])));
}

function defineFont(name, defs) {
	Fonts[name] = `kent-font-${name}-override, kent-font-${name}, sans-serif`;
	reisy.nodes([fontDef(name, defs), node('Fonts', name, [], decl(Fonts[name]))]);
}

defineFont('title', [{
	url: 'af1728-light.woff',
	weight: 'normal',
	style: 'normal',
}, {
	url: 'af1728-bold.woff',
	weight: 'bold',
	style: 'normal',
}]);

defineFont('subtitle', [{
	url: 'minion_pro_reg.woff',
	weight: 'normal',
	style: 'normal',
}, {
	url: 'minion_pro_it.woff',
	weight: 'normal',
	style: 'italic',
}]);

defineFont('text', [{
	url: 'af1728-light.woff',
	weight: 'normal',
	style: 'normal',
}]);

defineFont('aside', [{
	url: 'Roboto-Regular.woff',
	weight: 'normal',
	style: 'normal',
}]);

defineFont('pagestrip', [{
	url: 'DINPro-Medium.woff',
	weight: 'normal',
	style: 'normal',
}, {
	url: 'DINPro-Bold.woff',
	weight: 'bold',
	style: 'normal',
}]);

export default Fonts;



// WEBPACK FOOTER //
// ./lib/styling/fonts.js